import { render, staticRenderFns } from "./StockEstampillas.vue?vue&type=template&id=cf5e5922&scoped=true&"
import script from "./StockEstampillas.vue?vue&type=script&lang=js&"
export * from "./StockEstampillas.vue?vue&type=script&lang=js&"
import style0 from "./StockEstampillas.vue?vue&type=style&index=0&id=cf5e5922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5e5922",
  null
  
)

export default component.exports